export class AnswerValueDto {
    readonly optionId: string;

    constructor(optionId: string) {
        this.optionId = optionId;
    }
}
